export const convertStringToTime = (value: string) => {
    const timeParts = value.split(":");
    const hours = Number(timeParts[0]);
    const minutes = Number(timeParts[1]);

    return hours * 4 + Math.floor(minutes / 15);
};

/**
 *
 * @param value
 * @returns string in format HH:MM
 */
export const convertTimeToString = (value: number) => {
    const hours = Math.floor(value / 4);
    const minutes = (value % 4) * 15;

    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");

    return `${paddedHours}:${paddedMinutes}`;
};

/**
 * converts a time value to a object which can be used by moment set function
 *
 * @param value
 * @returns object with hours and minutes
 */
export const convertTimeToMoment = (value: number) => {
    const hours = Math.floor(value / 4);
    const minutes = (value % 4) * 15;

    return {
        hours,
        minutes,
    };
};
